import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AccessCardTypeEnum } from '@zaoblako/shared/modules/pacs/enums/access-card-type.enum';
import { AccessCardTypeEnumI18n } from '@zaoblako/shared/modules/pacs/i18n/access-card-type-enum.i18n';

@Pipe({
  name: 'accessCardTypeName',
  standalone: true
})
export class AccessCardTypeNamePipe implements PipeTransform {
  public transform(type: AccessCardTypeEnum): string {
    return AccessCardTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
